import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const moduleNavigation = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    activeComponent: "",
    previousComponent: "",
    lastComponentSwatchApplied: "",
    menu: {}
  }
};

export default moduleNavigation;
